import { AUTH_URL } from "../../urls.api";

export const NEW_PASSWORD_URL = `${AUTH_URL}/new-password`;
